import styled from "@emotion/native";
import { Platform } from "react-native";
import Button from "../../../../components/Button";
import { ViewStyle } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Options } from "../../styles";
import Text from "../../../../components/Text";

export const Main = styled.View({});
export const MainScroll = styled.ScrollView(
    {
        flex: 1,
        overflow: Platform.OS === ("android" || "web") ? "scroll" : "visible",
    },
    () => {
        const insets = useSafeAreaInsets();
        const marginBottom = insets.bottom > 0 ? insets.bottom : 20;

        let style: ViewStyle = {
            marginBottom,
        };

        return style;
    },
);

MainScroll.defaultProps = {
    contentContainerStyle: { flexGrow: 1 },
};

export const FollowUp = styled.View({
    paddingVertical: 80,
});

export const KnowledgeTestFollowUp = styled.View({
    marginTop: 12,
});

export const FollowUpCta = styled(Button)({});

export const ProgressSingle = styled(Text)({
    // marginTop: -70,
    textAlign: "center",
    marginBottom: 17,
});

export const OptionsSingle = styled(Options)({
    marginTop: 28,
});
